module.exports = __webpack_public_path__ + "static/img/2_1_3_2.f34a769e.jpg";